import { render, staticRenderFns } from "./DataAdminTab.vue?vue&type=template&id=d9c62af4&scoped=true"
import script from "./DataAdminTab.vue?vue&type=script&lang=ts"
export * from "./DataAdminTab.vue?vue&type=script&lang=ts"
import style0 from "./DataAdminTab.vue?vue&type=style&index=0&id=d9c62af4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9c62af4",
  null
  
)

export default component.exports